export const PrevSvg = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M4.86201 8.47132C4.60166 8.21097 4.60166 7.78886 4.86201 7.52851L9.52868 2.86185C9.78903 2.6015 10.2111 2.6015 10.4715 2.86185C10.7318 3.1222 10.7318 3.54431 10.4715 3.80466L6.27622 7.99992L10.4715 12.1952C10.7318 12.4555 10.7318 12.8776 10.4715 13.138C10.2111 13.3983 9.78903 13.3983 9.52868 13.138L4.86201 8.47132Z" fill="#4A5565"/>
</svg>

  )
}
